import { useState } from "react";
import StudioHome from "./StudioHome";
import DesignEditor from "./DesignEditor";
// import "./studio.css";
import PageLayout from "../../components/layouts/PageLayout";
import CustomNavbar from "../../components/common/CustomNavbar";
import VideoEditor from "./video/VideoEditior";
import type { VideoStart } from "../../types/videoType";

type StudioView =
  | {
      name: "home";
      at: number;
    }
  | {
      name: "design";
      id: number | string;
    }
  | {
      name: "video";
      start?: VideoStart;
    };

interface StudioProps {
  initialDesignId?: number | string | null;
}

export default function Studio({ initialDesignId = null }: StudioProps) {
  const [view, setView] = useState<StudioView>(
    initialDesignId !== null
      ? {
          name: "design",
          id: initialDesignId,
        }
      : {
          name: "home",
          at: Date.now(),
        },
  );
  const home = () => setView({ name: "home", at: Date.now() });

   const openDesign = (id: number | string) => {
    setView({
      name: "design",
      id,
    });
  };

  return (
    <PageLayout
      customNavbar={
        <CustomNavbar>
          <div className="flex gap-3 items-center w-max">
            <span className="font-bold text-lg uppercase">STUDIO</span>
          </div>
        </CustomNavbar>
      }
    >
      <div className="st-root  font-studio text-st-ink">
        {view.name === "home" && (
          <StudioHome
            key={view.at}
            onOpenDesign={openDesign}
            onNewVideo={() => setView({ name: "video" })}
          />
        )}
        {view.name === "design" && (
          <DesignEditor
            designId={view.id}
            onClose={home}
            onOpenVideo={(start) => setView({ name: "video", start })}
          />
        )}
        {view.name === "video" && <VideoEditor onClose={home} start={view.start} />}
      </div>
    </PageLayout>
  );
}
